import { client } from './client';

import { ApiResponse } from '../types/ApiResponse';

export type Country = {
  custom_без_номера: boolean;
  custom_название: string;
  custom_номер: number
}

export async function get<T>(categoryId: number, listId?: number): Promise<Array<T & { key: string }>> {
  const response = await client.get<ApiResponse<T>>(
    `/${process.env.REACT_APP_API_KEY}t${categoryId}r/json/v2`,
    {
      headers: listId ? {
        view: `${process.env.REACT_APP_API_KEY}ts5c${categoryId}cs9r${listId}`,
      } : {},
    }
  );

  return response.data.list.map(item => ({
    key: item.key,
    ...item.fields,
  }));
}